<div class="login-content">
  <img
    class="close-icon"
    src="./../../../../assets/icons/x.svg"
    alt=""
    (click)="onNoClick()"
  />

  <div class="login-content-logo">
    <img src="../../../../assets/logo/Logo.svg" alt="" />
  </div>
  <p class="title">Not Available!</p>

  <p class="paragraph2">
    This add-on is not available because there aren't enough providers to share
    your project brief with that matches your project details.
  </p>

  <button class="primary-btn" type="submit" (click)="onNoClick()">OK</button>
</div>
